<template>
    <div class="flex flex-wrap">
        <div class="w-full md:w-5/6 md:mx-auto px-3">
            <h1 class="mt-32 text-center font-bold">Oops!</h1>
            <p class="text-lg">Sorry, that page cannot be found. <router-link tag="a" :to="{ name: 'home' }">Click&nbsp;here</router-link> to visit the home page.</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'error'
    }
</script>
